import { InspirationDeck } from '@/components/cards/inspiration-deck';
import { Button } from '@/components/ui/button';
import { useState } from 'react';
import EditableDescription from '@/components/editable-description';
import { useAdminPreview } from '@/lib/admin-preview-context';

export default function InspiratiekaartenPage() {
  const [showThemes, setShowThemes] = useState(true);
  const { effectiveRole } = useAdminPreview();
  const isHoofdhart = effectiveRole === 'hoofdhartuser';

  const selectedClass = isHoofdhart
    ? 'rounded-full bg-red-700 text-white hover:bg-red-600 border-red-700'
    : 'rounded-full bg-green-800 text-white hover:bg-green-700 border-green-800';
  const unselectedClass = isHoofdhart
    ? 'rounded-full border-red-700 text-black hover:bg-red-50'
    : 'rounded-full border-green-800 text-black hover:bg-green-50';

  return (
    <div className="min-h-screen p-8 space-y-8">
      <div className="space-y-8">
        <div className="space-y-4">
          <h2 className="text-2xl font-semibold">Inspiratiekaarten</h2>
          <EditableDescription
            pageKey="inspiratiekaarten"
            defaultText="Laat je via deze kaarten inspireren met een quote, oefening, vraag of grap."
            className="text-lg mb-6"
          />
          <div className="flex gap-2 mb-6">
            <Button
              variant="outline"
              className={showThemes ? selectedClass : unselectedClass}
              onClick={() => setShowThemes(true)}
            >
              Op thema
            </Button>
            <Button
              variant="outline"
              className={!showThemes ? selectedClass : unselectedClass}
              onClick={() => setShowThemes(false)}
            >
              Random
            </Button>
          </div>
          <InspirationDeck showThemes={showThemes} />
        </div>
      </div>
    </div>
  );
}
